import { Component } from '@angular/core';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';
import { GungSettingsApiUserListConfigService } from '../../../services/gung-settings-api-user-list-config.service';
import { GungModalService } from '../../../services/gung-modal/gung-modal.service';

@Component({
  selector: 'lib-gung-settings-api-users',
  templateUrl: './gung-settings-api-users.component.html',
  styleUrl: './gung-settings-api-users.component.scss'
})
export class GungSettingsApiUsersComponent extends GungSettingsBaseViewComponent{

  constructor(public config: GungSettingsApiUserListConfigService, protected modalService: GungModalService){
    super()
  }

  addUser(){
    this.modalService.openEditApiUser().then(res =>{
      
    })
  }
}
